/* eslint-disable no-underscore-dangle,@typescript-eslint/no-unused-vars */

xplenty.directive('runPackageEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./run-package-editor.html'),

      replace: true,

      scope: false,

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        '$stateParams',
        function ($scope, $stateParams) {
          $scope.showOperator = $scope.$parent.$parent._default.inputEdges.length >= 2;
          $scope.package = $scope.component.package_id ? { id: $scope.component.package_id } : null;
          $scope.package_id = $scope.component.package_id;
          $scope.package_name = $scope.component.package_name;
          $scope.query = {
            flow_type: 'dataflow',
            current_package: $stateParams.id,
          };

          $scope.onPackageChange = (packageItem) => {
            $scope.package = packageItem;
            $scope.package_id = packageItem.id;
          };

          $scope.$watch(
            'package',
            function (_package) {
              if (_package && _package.id) {
                $scope.component.package_id = _package.id;
                $scope.component.package_name = _package.name;
              } else {
                $scope.component.package_id = null;
              }
            },
            true,
          );
        },
      ],
    };
  },
]);
